import React, { useCallback } from "react";
import { Helmet } from "react-helmet"; // ADD THIS IMPORT
import "../../css/Home.css";
import Navbar from "../Navbar";
import Footer from "../Footer";
import ServiceNavigation from "./ServiceNavigation";
import { useLocation, useNavigate } from "react-router-dom";
import { ConfirmDialog } from "primereact/confirmdialog"; 
import config from "../../../config";
import Services from "../../../ProviderServices.json";
import ThurentEventForm from "../ThurentEventForm";
import OfferingsSection from "./OfferingSection";
import { offeringsData } from './OfferingData';
import HeroSection from "./HeroSection";
import { HeroSectionData } from './HeroSectionData';
import { eventServicesSeoMappings } from "./seoMappings"; // ADD THIS IMPORT

function RentFromTentHouse({ tentServiceType = "default" }) { // ADD prop
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get tent service type from EITHER:
  // 1. prop (for clean URLs like /tent-house-services-near-me)
  // 2. query parameter (for /service/rental-services-for-events?type=tent-house-near-me)
  const params = new URLSearchParams(location.search);
  const queryTentType = params.get("type");
  
  // Priority: Query param > Prop
  const finalTentType = queryTentType || tentServiceType;
  
  // Get SEO data
  const seoData = eventServicesSeoMappings[finalTentType] || eventServicesSeoMappings.default;

  // Offerings Section
  const { heading, subHeading, list, image, ABOUT_SECTION_TITLE,
    ABOUT_SECTION_SUBTITLE, ABOUT_SECTION_DESC,alt } = offeringsData.rentFormTentHouse;

  const service = Services.find((service) =>
    location.pathname.includes(service.slug)
  );

  return (
    <>
      {/* ADD HELMET HERE */}
      <Helmet>
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description} />
        <meta name="keywords" content={seoData.keywords} />
      </Helmet>
      
      <Navbar />
      <ServiceNavigation />
      <div className="th-service">
        <HeroSection
          service={service}
          providerListStorageKey={config.providerListStorageKey}
          data={HeroSectionData.rentFormTentHouse}
        />
        <div className="flex mt-5 justify-content-center lg:mt-0">
          <div
            className="event-form th-plan"
            style={{
              boxShadow: "none",
            }}
          >
            <ThurentEventForm />
          </div>
        </div>
      </div>
      <OfferingsSection
        heading={heading}
        subHeading={subHeading}
        offeringsList={list}
        image={image} 
        ABOUT_SECTION_TITLE={ABOUT_SECTION_TITLE}
        ABOUT_SECTION_SUBTITLE={ABOUT_SECTION_SUBTITLE}
        ABOUT_SECTION_DESC={ABOUT_SECTION_DESC}
        altdata ={alt}
      />   
      <ConfirmDialog />
      <Footer />
    </>
  );
}

export default RentFromTentHouse;